import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { FeatureService } from './core/services/feature.service';
import { ChatWidgetComponent } from './features/community/chat/chat-widget.component';
import { UnreadService } from './core/services/unread.service';
import { SlugContextService } from './core/services/slug-context.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, ChatWidgetComponent],
  template: `
    <div class="space-bg"
         *ngIf="slugSvc.space?.backgroundUrl"
         [style.backgroundImage]="'url(' + slugSvc.space!.backgroundUrl + ')'">
    </div>
    <div class="app-content">
      <router-outlet></router-outlet>
      <app-chat-widget *ngIf="auth.isAuthenticated() && featureSvc.isEnabled('chat')"></app-chat-widget>
    </div>
  `,
  styles: [`
    .space-bg {
      position: fixed;
      inset: 0;
      z-index: 0;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      pointer-events: none;
    }
    .app-content {
      position: relative;
      z-index: 1;
      min-height: 100vh;
    }
  `]
})
export class AppComponent implements OnInit {
  auth       = inject(AuthService);
  featureSvc = inject(FeatureService);
  slugSvc    = inject(SlugContextService);
  private unread = inject(UnreadService);

  ngOnInit() { this.unread.start(); }
}
